export default "__VITE_ASSET__BWKjSGzG__"